import { DashboardService } from "./../../../dashboard.service";
import { Component, OnInit } from "@angular/core";

import { BsModalRef } from "ngx-bootstrap/modal";
import { AccountantService } from "../accountant.service";

import { HotToastService } from "@ngneat/hot-toast";
import { Subject } from "rxjs";
import { InitialsDirective } from "../../../../utils/initials.directive";
import { NgIf, NgFor, NgClass } from "@angular/common";

@Component({
    selector: "app-quick-assign-staff-modal",
    templateUrl: "./quick-assign-staff-modal.component.html",
    imports: [
        NgIf,
        NgFor,
        NgClass,
        InitialsDirective,
    ]
})
export class QuickAssignStaffModalComponent implements OnInit {
  showNoAvailableUsersMessage = false;

  companyId: number = null;
  assignedUsers: number[] = null;

  availableUsers = [];
  selectedUsers = [];

  success = new Subject();

  options = {
    multiple: false,
    width: "300",
    templateSelection: (object: any) => {
      return object && object.name;
    },
    templateResult: (object: any) => {
      return object && object.name;
    },
  };

  constructor(
    public bsModalRef: BsModalRef,
    private accountantService: AccountantService,
    private toastr: HotToastService,
    private dashboardService: DashboardService
  ) {}

  ngOnInit(): void {
    this.accountantService
      .get_company_info()
      .then((info) => {
        console.log("company info loaded", info);
        this.availableUsers = info.accountants
          .filter((usr: any) => usr.access_level !== 1)
          .filter((usr: any) => this.assignedUsers.indexOf(usr.id) === -1);
      })
      .catch((err) => this.toastr.error("Failed to fetch staff members"))
      .finally(() => {
        if (this.availableUsers.length === 0) {
          this.showNoAvailableUsersMessage = true;
        }
      });
  }

  toggleUserSelection(user: any) {
    if (!this.selectedUsers.includes(user.id)) {
      this.selectedUsers.push(user.id);
      user.selected = true;
    } else {
      this.selectedUsers.splice(this.selectedUsers.indexOf(user.id), 1);
      user.selected = false;
    }
  }

  assignUsers(): void {
    const newlyAssignedUsers = this.selectedUsers.map((userId) =>
      this.availableUsers.find((u) => u.id === userId)
    );

    this.dashboardService.show_loading.next(true);
    this.accountantService
      .assignCompanyAccountants(this.companyId, this.selectedUsers)
      .subscribe(
        (res) => {
          this.success.next(newlyAssignedUsers);
          this.toastr.success(res.message);
          this.dashboardService.show_loading.next(false);
          this.bsModalRef.hide();
        },
        (err) => {
          this.toastr.error(err.error.message);
          this.dashboardService.show_loading.next(false);
          this.bsModalRef.hide();
        }
      );
  }
}
